import React, { useEffect, useRef } from "react";
import { useLang } from "../i18n/LangContext";
import "../components/MobilePhone.css";

const names = ["Anne", "Timo", "Janne", ""];
const delays = [300, 1400, 2500, 3600];
const times = ["now", "1m", "3m", "6m"];

const Screen3: React.FC = () => {
  const { t } = useLang();
  const s = t.screens.s3;
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const notifs = wrapRef.current?.querySelectorAll(".notif");
    notifs?.forEach((n) => {
      const el = n as HTMLElement;
      el.classList.remove("show");
      setTimeout(() => el.classList.add("show"), Number(el.dataset.delay || 0));
    });
  }, []);

  return (
    <div className="mobile-screen-page" ref={wrapRef}>
      <div className="mobile-wrap">
        <div className="phone">
          <div className="phone-screen">
            <div className="notch" />
            <div className="statusbar">
              <div>09:41</div>
              <div>78%</div>
            </div>
            <div className="phone-content">
              <div className="lock-time">09:41</div>
              <div className="lock-sub">{s.lockSub}</div>
              <div className="notif-wrap">
                {s.notifs.map((n, i) => (
                  <div className="notif" data-delay={delays[i]} key={i}>
                    <div className="app-icon">W</div>
                    <div className="notif-body">
                      <div className="notif-top">
                        <div>Worklly</div>
                        <div className="notif-time">{times[i]}</div>
                      </div>
                      <div className="notif-title">{n.title}</div>
                      <div className="notif-text">
                        {names[i] ? (
                          <>{n.text.split("{name}")[0]}<strong>{names[i]}</strong>{n.text.split("{name}")[1]}</>
                        ) : (
                          <strong>{n.text}</strong>
                        )}
                      </div>
                      <div className="notif-badge">{n.badge}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="home-indicator" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Screen3;
